import {ScriptHTMLAttributes} from 'react';
const alreadyLoaded = new Map<string, HTMLScriptElement>();

export type loadScriptStateType = 'idle' | 'pending' | 'success' | 'error';

export type scriptOptions = ScriptHTMLAttributes<HTMLScriptElement> & {
  ['data-client-id']?: string;
  /** Can be used to not fetch the script multiple times if it was already loaded to avoid executing the same code over and over again */
  ['isApiAvailable']?: () => boolean;
};

export async function importGlobalScript(
  url: string,
  setLoadScriptState: (state: loadScriptStateType) => void,
  options?: scriptOptions,
) {
  return new Promise<void>(resolve => {
    if (alreadyLoaded.has(url)) {
      resolve();

      return;
    }

    const script = document.createElement('script');

    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });
    }

    script.onload = () => {
      alreadyLoaded.set(url, script);
      setLoadScriptState('success');
      resolve();
    };

    script.onerror = () => {
      script.remove();
      alreadyLoaded.delete(url);
      setLoadScriptState('error');

      // We don't want to reject to avoid tracking expected network errors in this case.
      resolve();
    };

    script.src = url;

    document.body.appendChild(script);
  });
}

export function removeGlobalScript(url: string) {
  const element = alreadyLoaded.get(url);
  if (element) {
    element.remove();
    alreadyLoaded.delete(url);
  }
}
